import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      *:not(:focus-within) & {\n        ", "\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      ", " ", "ms var(", ") both\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  width: ", "%;\n  line-height: 20px;\n\n  transform-origin: top left;\n  transition-property: ", "\n    color;\n\n  animation: ", ";\n\n  cursor: ", ";\n\n  ", "\n\n  [dir='rtl'] & {\n    transform-origin: top right;\n  }\n\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  transition-property: color;\n  ", "\n\n  ", " {\n    ", "\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    &[for] {\n      cursor: pointer;\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 0;\n\n  color: var(", ");\n\n  transform-origin: top left;\n\n  transition-timing-function: var(", ");\n  transition-duration: ", "ms;\n\n  cursor: ", ";\n\n  ", "\n  ", "\n\n  [dir='rtl'] & {\n    transform-origin: top right;\n  }\n\n  ", "\n\n  label&:hover,\n  label &:hover {\n    color: var(", ");\n  }\n\n  *:focus-within > & {\n    color: var(", ");\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n\n  color: var(", ");\n\n  transform-origin: bottom left;\n\n  transition-timing-function: var(", ");\n  transition-duration: ", "ms;\n  transition-property: transform;\n\n  [dir='rtl'] & {\n    transform-origin: bottom right;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        animation-name: ", ";\n\n        /* Inverse of the above scale factor to retain it's original size */\n        ", " {\n          transform: scale(", ") translateY(-0.1ex);\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        transform: scale(", ");\n\n        /* Inverse of the above scale factor to retain it's original size */\n        ", " {\n          transform: scale(", ") translateY(-0.1ex);\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    0% {\n      ", "\n    }\n    0.001% {\n      width: ", "%;\n\n      font-size: var(", ");\n\n      transform:\n        translateY(calc(", " - ", "))\n        scale(", ");\n    }\n    100% {\n      ", "\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      0% {\n        ", "\n      }\n      0.001% {\n        width: 100%;\n\n        font-size: var(", ");\n\n        transform: \n          translateY(calc(", "))\n          scale(", ");\n      }\n      100% {\n        ", "\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n\n    font-size: var(", ");\n\n    transform: translateY(calc(", "));\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: ", "%;\n\n    font-size: var(", ");\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css, keyframes } from 'styled-components';
import { injectTypography } from '../../utils/injectTypography';
import { getEasing } from '../../utils/getEasing';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
var animationDuration = 250;
/* ⚠️ This factor is the result of dividing `copy2` by `copy1` font size for
 * decrease and vice versa for increase.
 * This is necessary since `transform: scale()` does not work with units, so the
 * factor needed to be hard coded and must be updated when typography
 * tokens change.
 */

var widthScaleFactorDecrease = 12 / 16;
var widthScaleFactorIncrease = 16 / 12;

var floatKeyframes = function floatKeyframes(_ref) {
  var theme = _ref.theme;
  var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _theme$responsive$typ = theme.responsive.typography.copy1,
      lineHeight = _theme$responsive$typ.lineHeight,
      fontSizeBig = _theme$responsive$typ.fontSize;
  var fontSizeSmall = theme.responsive.typography.copy2.fontSize;
  var fontSizeDelta = "(var(".concat(fontSizeBig, ") - var(").concat(fontSizeSmall, "))");
  var verticalAlignAdjust = "".concat(fontSizeDelta, " / 2");
  var translateY = "(var(".concat(lineHeight, ") + ").concat(verticalAlignAdjust, ")");
  var stateSmall = css(_templateObject(), 100 * widthScaleFactorDecrease, fontSizeSmall);
  var stateBig = css(_templateObject2(), fontSizeBig, translateY);

  if (reverse) {
    return keyframes(_templateObject3(), stateSmall, fontSizeBig, verticalAlignAdjust, widthScaleFactorDecrease, stateBig);
  }

  return keyframes(_templateObject4(), stateBig, 100 * widthScaleFactorDecrease, fontSizeSmall, translateY, fontSizeDelta, widthScaleFactorIncrease, stateSmall);
};

var injectAnimationStyles = function injectAnimationStyles(props) {
  switch (props.variant) {
    case 'scale':
      return css(_templateObject5(), widthScaleFactorIncrease, StyledOptionalText, widthScaleFactorDecrease);

    case 'float':
      return css(_templateObject6(), floatKeyframes(props, true), StyledOptionalText, widthScaleFactorDecrease);

    case 'static':
    case 'default':
    default:
      return false;
  }
};

export var StyledOptionalText = styled.span(_templateObject7(), function (props) {
  return props.theme.colors.ui.tertiary;
}, getEasing, animationDuration);

var getStateColor = function getStateColor(_ref2) {
  var theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, ["theme"]);

  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  if (props.disabled) return theme.colors.interaction.label.disabled;
  if (props.invalid) return theme.colors.ui.error;
  return theme.colors.interaction.label[color];
};

export var injectCommonStyles = function injectCommonStyles(props) {
  return css(_templateObject8(), getStateColor(props, !props.empty ? 'filled' : undefined), getEasing, animationDuration, props.disabled && 'not-allowed', injectOSXFontSmoothing(true), injectSpacing('margin')(props), !(props.disabled || props.readOnly) && css(_templateObject9()), getStateColor(props, 'hover'), getStateColor(props, 'focus'));
};

function filterLabelProps(prop, defaulValidatorFunction) {
  return !['required', 'disabled', 'readOnly'].includes(prop.toString()) && defaulValidatorFunction(prop);
}

export var StyledStaticLabel = styled.label.withConfig({
  shouldForwardProp: filterLabelProps
})(_templateObject10(), injectCommonStyles, function (props) {
  return props.variant === 'static' ? injectTypography(props, 'copy1') : injectTypography(props, 'copy2');
}, StyledOptionalText, function (props) {
  return injectTypography(props, 'copy2');
});
export var StyledAnimatedLabel = styled.label.withConfig({
  shouldForwardProp: filterLabelProps
})(_templateObject11(), injectCommonStyles, 100 * widthScaleFactorDecrease, function (props) {
  return props.variant === 'scale' && 'transform,';
}, function (props) {
  return props.variant === 'float' && css(_templateObject12(), floatKeyframes, animationDuration, getEasing);
}, function (props) {
  return props.disabled && 'not-allowed';
}, function (props) {
  return injectTypography(props, 'copy2');
}, function (props) {
  return props.empty && css(_templateObject13(), injectAnimationStyles(props));
});